module.exports = __webpack_public_path__ + "static/media/trees.da83e9b0.png";